function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

var ChangePageModifier = function (page) {
  if (window.history && history.pushState) {
    var newUrl = updateQueryStringParameter(window.location.href, "p", page);
    history.pushState({}, '', newUrl);

  }
}

export default ChangePageModifier;